<template>
    <lv-base-column
        ref="column"
        v-bind="columnBinding"
        :externalData="{option,showKey,map}">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-object-item
                :row="row"
                :edit-row="editRow"
                :row-index="rowIndex"
                :col="col"
                :col-index="colIndex"
                :fixed-row="fixedRow"
                v-bind="columnItemBinding"
                @click="lv_clickItem"

                :option="option"
                :show-key="showKey"
                :map="map"

                :beforeSelect="beforeSelect"
                :afterSelect="afterSelect"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import LinkTableColumnObjectItem from "./link-table-column-object-item";
    import {ColumnMixin} from "../mixins";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: "link-table-column-object",
        components: {LinkTableColumnObjectItem, LvBaseColumn},
        mixins: [ColumnMixin,],
        props: {
            option: {required: true},
            showKey: {required: true},
            map: {required: true},

            beforeSelect: {type: Function},
            afterSelect: {type: Function},

            filterName: {default: 'picklist'},

            getChangeField: {
                default() {
                    return () => {
                        const keys = new Set(Object.keys(this.map || {}))
                        keys.add(this.showKey)
                        return Array.from(keys)
                    }
                }
            },
        },

    }
</script>
